Object.defineProperty(exports,"__esModule",{value:true});var _isFunction2=require("lodash/isFunction");var _isFunction3=_interopRequireDefault(_isFunction2);var _defaults2=require("lodash/defaults");var _defaults3=_interopRequireDefault(_defaults2);var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);

var _index=require("../victory-primitives/index");function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var

VictoryClipContainer=function(_React$Component){_inherits(VictoryClipContainer,_React$Component);




























function VictoryClipContainer(props){_classCallCheck(this,VictoryClipContainer);var _this=_possibleConstructorReturn(this,(VictoryClipContainer.__proto__||Object.getPrototypeOf(VictoryClipContainer)).call(this,
props));
_this.clipId=Math.round(Math.random()*10000);return _this;
}_createClass(VictoryClipContainer,[{key:"renderClippedGroup",value:function renderClippedGroup(


props,clipId){var
style=props.style,events=props.events,transform=props.transform,children=props.children,className=props.className;
var clipComponent=this.renderClipComponent(props,clipId);
return(
_react2.default.createElement("g",_extends({
className:className,
style:style},
events,{
transform:transform}),

clipComponent,
_react2.default.createElement("g",{clipPath:"url(#"+clipId+")"},
children)));



}},{key:"renderGroup",value:function renderGroup(


props){var
style=props.style,events=props.events,transform=props.transform,children=props.children,className=props.className;
return(
_react2.default.createElement("g",_extends({
className:className,
style:style},
events,{
transform:transform}),

children));


}},{key:"renderClipComponent",value:function renderClipComponent(


props,clipId){var

clipPadding=
props.clipPadding,translateX=props.translateX,translateY=props.translateY,clipHeight=props.clipHeight,clipWidth=props.clipWidth,clipPathComponent=props.clipPathComponent;
return _react2.default.cloneElement(
clipPathComponent,
{clipPadding:clipPadding,clipId:clipId,translateX:translateX,translateY:translateY,clipWidth:clipWidth,clipHeight:clipHeight});

}},{key:"getClipValue",value:function getClipValue(

props,axis){
var clipValues={x:props.clipWidth,y:props.clipHeight};
if(clipValues[axis]!==undefined){
return clipValues[axis];
}
var range=this.getRange(props,axis);
return range?Math.abs(range[0]-range[1])||undefined:undefined;
}},{key:"getTranslateValue",value:function getTranslateValue(

props,axis){
var translateValues={x:props.translateX,y:props.translateY};
if(translateValues[axis]!==undefined){
return translateValues[axis];
}
var range=this.getRange(props,axis);
return range?Math.min.apply(Math,_toConsumableArray(range)):undefined;
}},{key:"getRange",value:function getRange(

props,axis){
var scale=props.scale||{};
if(!scale[axis]){
return undefined;
}
return(0,_isFunction3.default)(scale[axis].range)?scale[axis].range():undefined;
}},{key:"render",value:function render()

{
var clipHeight=this.getClipValue(this.props,"y");
var clipWidth=this.getClipValue(this.props,"x");
if(clipWidth===undefined||clipHeight===undefined){
return this.renderGroup(this.props);
}
var translateX=this.getTranslateValue(this.props,"x");
var translateY=this.getTranslateValue(this.props,"y");
var clipProps=(0,_defaults3.default)({},this.props,{clipHeight:clipHeight,clipWidth:clipWidth,translateX:translateX,translateY:translateY});
return this.renderClippedGroup(clipProps,this.clipId);
}}]);return VictoryClipContainer;}(_react2.default.Component);VictoryClipContainer.displayName="VictoryClipContainer";VictoryClipContainer.role="container";VictoryClipContainer.propTypes={className:_react.PropTypes.string,style:_react.PropTypes.object,clipPadding:_react.PropTypes.shape({top:_react.PropTypes.number,bottom:_react.PropTypes.number,left:_react.PropTypes.number,right:_react.PropTypes.number}),clipHeight:_react.PropTypes.number,clipWidth:_react.PropTypes.number,events:_react.PropTypes.object,children:_react2.default.PropTypes.oneOfType([_react2.default.PropTypes.arrayOf(_react2.default.PropTypes.node),_react2.default.PropTypes.node]),clipPathComponent:_react.PropTypes.element,translateX:_react.PropTypes.number,translateY:_react.PropTypes.number,transform:_react.PropTypes.string};VictoryClipContainer.defaultProps={clipPathComponent:_react2.default.createElement(_index.ClipPath,null)};exports.default=VictoryClipContainer;


//////////////////
// WEBPACK FOOTER
// ./~/victory-core/lib/victory-clip-container/victory-clip-container.js
// module id = 1466
// module chunks = 0